import AcademicSetting from './academicSetting'
import Attachment from './attachment'
import CmOptionEnum from './cmOptionEnum'
import FrontRandom from './frontRandom'
import OptionEnum from './optionEnum'
import Payment from './payment'
import RegistrationForm from './registrationForm'
import UniversalFile from './universalFile'

export default {
  AcademicSetting,
  Attachment,
  CmOptionEnum,
  FrontRandom,
  OptionEnum,
  Payment,
  RegistrationForm,
  UniversalFile,
}
